import Marquee from "react-fast-marquee";
import { Droplets } from "lucide-react";

const phrases = [
  { text: "Save money.", accent: false },
  { text: "Save water.", accent: true },
  { text: "No property damage.", accent: false },
];

export default function PhraseMarquee({ speed = 30, className = "" }) {
  return (
    <div
      data-testid="value-marquee"
      className={`relative border-y border-white/10 bg-[#060606] py-8 lg:py-10 ${className}`}
    >
      <Marquee speed={speed} gradient={false} autoFill>
        {phrases.map((p, i) => (
          <div key={i} className="flex items-center">
            <span
              className={`font-marquee uppercase text-[8vw] md:text-6xl lg:text-7xl leading-none px-6 ${
                p.accent ? "text-[#169ED9] text-glow" : "text-white"
              }`}
            >
              {p.text}
            </span>
            <Droplets
              className="mx-2 h-6 w-6 lg:h-8 lg:w-8 text-[#169ED9]/70 shrink-0"
              strokeWidth={1.6}
            />
          </div>
        ))}
      </Marquee>
    </div>
  );
}
